export const QueryKeys = {
  ENUMERATOR: "enumerator",
  RECRUITER: "recruiter",
  JOBS: "jobs",
  NOTIFICATIONS: "notifications",
  ACTIVITY: "activity",
  CANDIDATE: "candidate",
};
